<div class="container py-3">

  <div class="dashboard-top">
				<button mat-icon-button  color="primary" (click)="reload()">
						<mat-icon>sync</mat-icon>
				</button>
			</div>
			<div class="dashboard-header">
				<button type="button" (click)="goBack()" mat-button>
					<mat-icon>chevron_left</mat-icon>
				</button>
				<h2 class="webapp-title-secondary">{{ table | uppercase}}</h2>
      </div>

  <div class="d-flex align-items-center justify-content-between margin-1rem">
      
    <!-- CREATE BUTTON -->
    <button *ngIf="crudStatus == 'read'" mat-button (click)="crudStatus = 'create'">
      <mat-icon>add_circle</mat-icon>
    </button>

    <!-- SEARCH -->
    <div class="input-group" style="max-width: 340px;">
      <input class="form-control"
             [(ngModel)]="search" [ngModelOptions]="{standalone: true}"
             placeholder="Buscar..." (keyup.enter)="page=1; loadData()" />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="page=1; loadData()">Buscar</button>
      </div>
    </div>
  </div>

  <!-- CREATE / UPDATE -->
  <div class="card mb-4 shadow-sm" *ngIf="crudStatus == 'create' || crudStatus == 'update'">
    <div class="card-body">
      <button (click)="onCancelEdit()" class="btn btn-secondary btn-sm">
          <i class="fas fa-times"></i>
      </button>
      <form *ngIf="form as fg" [formGroup]="fg" (ngSubmit)="editing ? onUpdate() : onCreate()">
        <div class="form-row">

          <ng-container *ngFor="let c of (meta?.columns || [])">
            <ng-container *ngIf="!c.isPrimaryKey">

              <!-- SELECT para FK -->
              <!-- Para columnas FK -->
              <div class="form-group col-md-6" *ngIf="isForeign(c)">
                <label>{{ displayLabel(c) }}</label>
                <select class="form-control" [formControlName]="c.name">
                    <option [ngValue]="''">-- seleccionar --</option>
                    <option *ngFor="let opt of fkOptions[c.name] || []" [ngValue]="opt.id"
                            [title]="(opt.label || ('#' + opt.id)) + ' | ' + (opt.data | json)">
                    {{ opt.label || ('#' + opt.id) }}
                    </option>
                </select>
                <small class="form-text text-muted" *ngIf="(fkOptions[c.name] || []).length">
                    {{ (fkLabelFields[c.name]?.join(' + ') || 'label por defecto del servidor') }}
                </small>
                <div class="invalid-feedback d-block" *ngIf="fg.get(c.name)?.invalid && fg.get(c.name)?.touched">
                    Campo requerido o inválido
                </div>
              </div>

              <!-- Campos NO FK -->
              <div class="form-group col-md-6" *ngIf="!isForeign(c) && !isTextArea(c)">
                <label>{{ displayLabel(c) }}</label>

                <ng-container [ngSwitch]="true">
                  <select *ngSwitchCase="isEnum(c)" class="form-control" [formControlName]="c.name">
                    <option [ngValue]="''">-- seleccionar --</option>
                    <option *ngFor="let v of c.enumValues" [ngValue]="v">{{ v }}</option>
                  </select>

                  <input *ngSwitchCase="isDate(c)" type="date" class="form-control" [formControlName]="c.name" />
                  <input *ngSwitchCase="isNumeric(c)" type="number" class="form-control" [formControlName]="c.name" />
                  <!-- BOOLEAN / tinyint -->
                  <div *ngSwitchCase="isBoolean(c)" style="width: 100%; margin: 1rem 0">
                    <mat-slide-toggle [formControlName]="c.name">{{c.name}}</mat-slide-toggle><!-- [checked]="inputValue"  (change)="onSlideToggleEvent($event)" -->
                  </div>
                  <!-- DEFAULT -->
                  <input *ngSwitchDefault type="text" class="form-control" [maxlength]="c.maxLength || null" [formControlName]="c.name" />
                </ng-container>

                <div class="invalid-feedback d-block" *ngIf="fg.get(c.name)?.invalid && fg.get(c.name)?.touched">
                  Campo requerido o inválido
                </div>
              </div>

              <div class="form-group col-12" *ngIf="!isForeign(c) && isTextArea(c)">
                <label>{{ displayLabel(c) }}</label>
                <textarea rows="3" class="form-control" [formControlName]="c.name"></textarea>
                <div class="invalid-feedback d-block" *ngIf="fg.get(c.name)?.invalid && fg.get(c.name)?.touched">
                  Campo requerido o inválido
                </div>
              </div>

            </ng-container>
          </ng-container>

        </div>

        <div>
          <h5>Debug:</h5>
          <span>{{ form.value | json }}</span>
        </div>

        <!-- ACTION BUTTONS -->
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary" [disabled]="fg.invalid">
            {{ editing ? 'Actualizar' : 'Crear' }}
          </button>
          <button *ngIf="editing" type="button" class="btn btn-secondary" (click)="onCancelEdit()">Cancelar</button>
        </div>
      </form>

      <div *ngIf="!form" class="text-muted">Cargando formulario…</div>
    </div>
  </div>

  <!-- READ / LIST -->
  <div class="table-responsive" *ngIf="crudStatus == 'read'">
    <table class="table table-hover table-bordered">
      <thead class="thead-light">
        <tr>
          <th *ngFor="let c of (meta?.columns || [])"
              (click)="sortBy(c.name)"
              style="cursor:pointer; white-space:nowrap;">
            {{ c.name }}
            <span *ngIf="sort === c.name">{{ dir === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th style="width: 120px;">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td *ngFor="let c of (meta?.columns || [])">{{ row[c.name] }}</td>
          <td>
            <button class="btn btn-sm btn-outline-primary mr-2" (click)="onEdit(row)">Editar</button>
            <button class="btn btn-sm btn-outline-danger" (click)="onDelete(row)">Eliminar</button>
          </td>
        </tr>
        <tr *ngIf="!rows.length">
          <td [attr.colspan]="(meta?.columns?.length || 0) + 1" class="text-center text-muted">
            Sin resultados
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex align-items-center justify-content-between margin-1rem">
    <div class="text-muted">Total: {{ total }}</div>
    <div>
      <!-- PREV -->
      <button type="button" [disabled]="page<=1" (click)="page=page-1; loadData()" mat-button>
        <mat-icon>chevron_left</mat-icon>Prev
      </button>
      <span>Page {{ page }}</span>
      <!-- NEXT -->
      <button type="button" [disabled]="page * pageSize >= total" (click)="page=page+1; loadData()" mat-button>
        <mat-icon>chevron_right</mat-icon>Next
      </button>
    </div>
    <div>
      <select class="form-control" style="width:auto; display:inline-block"
              [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}"
              (change)="page=1; loadData()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
      </select>
    </div>
  </div>
</div>
